type ColorName =
  'black'
  | 'blue'
  | 'bright-blue'
  | 'midnight-blue'
  | 'peaceful-blue'
  | 'gray'
  | 'alternative-gray'
  | 'nobel'
  | 'blue-gray'
  | 'spanish-gray'
  | 'light-blue-gray'
  | 'light-blue'
  | 'curious-blue'
  | 'pattens-blue'
  | 'dark-gray'
  | 'light-gray'
  | 'white-smoke'
  | 'bright-green'
  | 'positive-green'
  | 'forest-green'
  | 'gum-leaf-green'
  | 'orange'
  | 'bright-red'
  | 'dangerous-red'
  | 'white'
  | 'bright-yellow'
  | 'golden-yellow'
  | 'stressful-yellow'
  | 'history-chart-schufa-blue'
  | 'history-chart-optimization-green'
  | 'schufa-platform-yellow'
  | 'schufa-platform-light-yellow'
  | 'schufa-platform-bright-yellow'
  | 'score-insufficient'
  | 'score-inadequate'
  | 'score-sufficient'
  | 'score-satisfying'
  | 'score-good'
  | 'score-very-good'
  | 'score-invalid'
  | 'score-invalid-dark-gray'
  | 'score-invalid-gray'
  | 'score-invalid-light-gray'

function color (name: ColorName): string {
  switch (name) {
    case 'blue': return '#0066b3'
    case 'bright-blue': return '#e9faff'
    case 'midnight-blue': return '#0e2472'
    case 'peaceful-blue': return '#00b9ff'
    case 'black': return '#000'
    case 'gray': return '#dcdcdc'
    case 'alternative-gray': return '#828282'
    case 'nobel': return '#949494'
    case 'blue-gray': return '#abc5d8'
    case 'spanish-gray': return '#979797'
    case 'light-blue-gray': return '#e5eff7'
    case 'light-blue': return '#87b4e1'
    case 'curious-blue': return '#2382c8'
    case 'pattens-blue': return '#d7f5ff'
    case 'dark-gray': return '#333333'
    case 'light-gray': return '#b2b2b2'
    case 'white-smoke': return '#f5f5f5'
    case 'bright-green': return '#ecffd2'
    case 'positive-green': return '#90d02b'
    case 'forest-green': return '#1ea532'
    case 'gum-leaf-green': return '#bbe4c2'
    case 'orange': return '#f60'
    case 'bright-yellow': return '#fff5e2'
    case 'golden-yellow': return '#ffe300'
    case 'stressful-yellow': return '#ffb900'
    case 'white': return '#fff'
    case 'bright-red': return '#fff1f0'
    case 'dangerous-red': return '#d90000'
    case 'history-chart-schufa-blue': return '#0f2364'
    case 'history-chart-optimization-green': return '#1ea532'
    case 'schufa-platform-yellow': return '#ffc235'
    case 'schufa-platform-light-yellow': return '#fae6b0'
    case 'schufa-platform-bright-yellow': return '#fff3d7'
    case 'score-invalid': return '#989898'
    case 'score-insufficient': return '#96001e'
    case 'score-inadequate': return '#d41c01'
    case 'score-sufficient': return '#cd8c2f'
    case 'score-satisfying': return '#ffb900'
    case 'score-good': return '#77b610'
    case 'score-very-good': return '#198229'
    case 'score-invalid-dark-gray': return '#4b4b4b'
    case 'score-invalid-gray': return '#9b9b9b'
    case 'score-invalid-light-gray': return '#aeaeae'

    default: throw new Error('please specify color name')
  }
}

export { color }
